/*
  Итог вкладки «Начисления» и уведомление о расхождении с 1С (23.10.2026).

  Итог - по всему счёту, а не по странице: считает сервер (`/charge-totals`), страница
  показывает десять строк из шестидесяти, и сумма по ней была бы неправдой. Слова - из
  макета 6А: «Итого начислено …, оплачено …, долг …». Компонент только рисует: итог
  загружает и перечитывает вкладка (`ChargesTab`).

  Решение владельца 23.10.2026: «главная цифра это ручной ввод, а с 1С это сверка».
  Если по строкам ручного ввода 1С прислала другие суммы, вкладка говорит об этом
  уведомлением - и ничего не делает: исправлять или нет, решает человек.
*/

import { money, rows as rowsWord } from '../../api/format.js'
import { Notice } from '../Common.jsx'

export default function ChargeTotals({ totals, error }) {
  if (error) return <Notice error={error} />
  if (!totals || totals.rows === 0) return null
  return (
    <>
      {totals.differs_from_onec > 0 ? (
        <Notice kind="warn">
          Есть расхождение с 1С: {rowsWord(totals.differs_from_onec)}. Главные цифры - внесённые
          вручную, они и идут в расчёт; присланное 1С показано у строки для сверки и ничего не
          меняет.
        </Notice>
      ) : null}
      <p className="muted">
        Итого начислено {money(totals.charged)}, оплачено {money(totals.paid)}, долг{' '}
        {money(totals.debt)}
      </p>
    </>
  )
}
